import React, { useRef } from 'react';
import { IconPlus } from '@noths/polaris-client-ribbons-design-system';

import { StarRating } from 'src/components/molecules/StarRating/StarRating';
import {
  HIDE_TEXT_ON_LINE,
  REVIEWED_ON,
} from 'src/components/organisms/ProductReviews/constants/copy';
import { dateFormatHelper } from 'src/components/organisms/ProductReviews/helpers/dateFormatHelper';
import { useExpandableText } from 'src/components/organisms/ProductReviews/hooks/useExpandableText';
import type { RarDataAPIReviewItem } from 'src/services/rar-data-api/types/RarDataAPIReviews';
import * as styles from './ProductReview.styles';

export interface FeaturedReviewProps {
  href: string;
  review: RarDataAPIReviewItem;
}

export const FeaturedReview = ({ href, review }: FeaturedReviewProps) => {
  const commentRef = useRef<HTMLParagraphElement>(null);
  const { height, lineCount } = useExpandableText({
    ref: commentRef,
    maxLines: HIDE_TEXT_ON_LINE,
  });

  return (
    <li css={styles.reviewItem}>
      <div css={styles.ratingSection}>
        <StarRating productRating={review.rating} />
        <span css={styles.dateText}>
          {REVIEWED_ON} {dateFormatHelper(review.date)}
        </span>
      </div>

      {review.comment && (
        <>
          <div
            style={{
              height,
              overflow: 'hidden',
            }}
          >
            <p css={styles.commentText} ref={commentRef}>
              {review.comment}
            </p>
          </div>
          {lineCount > HIDE_TEXT_ON_LINE && (
            <a css={styles.expandingButton} href={href}>
              <span css={styles.readMoreButtonText}>Read more</span>
              <IconPlus color={'var(--brand-purple-base)'} height={16} width={16} />
            </a>
          )}
        </>
      )}
    </li>
  );
};
